import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getBookingList, updateBookingServ } from "../../services/appointment.service";
import Skeleton from "react-loading-skeleton";
import NoRecordFound from "../../components/NoRecordFound";
import moment from "moment";
function AppointmentSchedule() {
  const [showSkelton, setShowSkelton] = useState(false);
  const [list, setList] = useState([]);
  const handleGetBookingList = async () => {
    if(list?.length==0){
      setShowSkelton(true);
    }
    try {
      let response = await getBookingList({ status: "scheduled" });
      if (response?.data?.success) {
        setList(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
    setShowSkelton(false);
  };
  useEffect(() => {
    handleGetBookingList();
  }, []);
  const [popupDetails, setPopUpDetails] = useState(null);
  const timeSlot = [
    "06:00-06:15",
    "06:15-06:30",
    "06:30-06:45",
    "06:45-07:00",
    "07:00-07:15",
    "07:15-07:30",
    "07:30-07:45",
    "07:45-08:00",
    "08:00-08:15",
    "08:15-08:30",
    "08:30-08:45",
    "08:45-09:00",
    "09:00-09:15",
    "09:15-09:30",
    "09:30-09:45",
    "09:45-10:00",
    "10:00-10:15",
    "10:15-10:30",
    "10:30-10:45",
    "10:45-11:00",
    "11:00-11:15",
    "11:15-11:30",
    "11:30-11:45",
    "11:45-12:00",
    "12:00-12:15",
    "12:15-12:30",
    "12:30-12:45",
    "12:45-13:00",
    "13:00-13:15",
    "13:15-13:30",
    "13:30-13:45",
    "13:45-14:00",
    "14:00-14:15",
    "14:15-14:30",
    "14:30-14:45",
    "14:45-15:00",
    "15:00-15:15",
    "15:15-15:30",
    "15:30-15:45",
    "15:45-16:00",
    "16:00-16:15",
    "16:15-16:30",
    "16:30-16:45",
    "16:45-17:00",
    "17:00-17:15",
    "17:15-17:30",
    "17:30-17:45",
    "17:45-18:00",
    "18:00-18:15",
    "18:15-18:30",
    "18:30-18:45",
    "18:45-19:00",
    "19:00-19:15",
    "19:15-19:30",
    "19:30-19:45",
    "19:45-20:00",
    "20:00-20:15",
    "20:15-20:30",
    "20:30-20:45",
    "20:45-21:00",
    "21:00-21:15",
    "21:15-21:30",
    "21:30-21:45",
    "21:45-22:00",
    "22:00-22:15",
    "22:15-22:30",
    "22:30-22:45",
    "22:45-23:00",
  ];
  const [formData, setFormData] = useState({
    scheduledDate: "",
    scheduledTime: "",
    status: "scheduled",
    id: popupDetails?._id,
  });
  const updateBookingFunc = async () => {
    setBtnLoader(true)
    try {
      let response = await updateBookingServ(popupDetails?._id, formData);
      if (response?.data?.statusCode == 200) {
        toast.success(response?.data.message);
        setFormData({
          scheduledDate: "",
          scheduledTime: "",
          status: "scheduled",
          id: "",
        });
        handleGetBookingList();
        setPopUpDetails(null);
      }
    } catch (error) {
      toast.success(error?.response?.data.message || "Internal Server Error");
    }
    setBtnLoader(false)
  };
  const [btnLoader, setBtnLoader]=useState(false)
  return (
    <div className="main_layout  bgBlack d-flex">
      {/* sectionLayout started */}
      <section className="section_layout d-flex">
        {/* sidebar started */}
        <Sidebar selectedItem="Appointment Schedule" />
        {/* sidebar ended */}
        <div className="w-100 me-5">
          <div className="ms-5 w-100">
            <div className="">
              <div className="tableBody borderRadius50All">
                <div>
                  <table className="table ">
                    <thead>
                      <tr style={{ background: "#EA9401", color: "#000" }}>
                        <th scope="col" style={{ borderRadius: "24px 0px 0px 24px" }}>
                          <div className="d-flex justify-content-center ms-2">
                            <span className="mx-2">Sr. No</span>
                          </div>
                        </th>
                        <th scope="col">Location</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">Contact Number</th>
                        <th scope="col">City</th>
                        <th scope="col">No. of kundali</th>
                        <th scope="col">Extra Time</th>
                        <th scope="col">Appointment Date</th>
                        <th scope="col">Schedule Time</th>
                        <th scope="col" style={{ borderRadius: "0px 24px 24px 0px" }}>
                          Action
                        </th>
                      </tr>
                    </thead>

                    <div className="pt-3 pb-2 "></div>
                    <tbody className="driverTable">
                      {showSkelton
                        ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((v, i) => {
                            return (
                              <tr className=" ">
                                <td>
                                  <Skeleton width={40} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                                <td>
                                  <Skeleton width={100} height={20} />
                                </td>
                              </tr>
                            );
                          })
                        : list?.map((v, i) => (
                            <>
                              <tr
                                key={i}
                                style={{
                                  background: i % 2 === 0 ? "#E8E8F2" : "#FFF0D7",
                                  cursor: "pointer",
                                  border: "2px solid red",
                                }}
                              >
                                <td scope="row" style={{ borderRadius: "12px 0px 0px 12px" }}>
                                  {i + 1}
                                </td>
                                <td>{v?.location}</td>
                                <td>{v?.fullName}</td>
                                <td>
                                  {v?.countryCode} {v?.contact}
                                </td>
                                <td>{v?.yourCity}</td>
                                <td>{v?.noOfKundali}</td>
                                <td>{v?.extraTime ? v?.extraTime : 0} mins</td>
                                <td> {moment(v?.scheduledDate).format("DD/MM/YYYY")}</td>
                                <td>{v?.scheduledTime}</td>

                                <td style={{ borderRadius: "0px 12px 12px 0px" }}>
                                  <button
                                    className="btn btn-primary"
                                    style={{
                                      marginTop: "-6px",
                                      background: "#000000",
                                      borderRadius: "6px",
                                      border: "none",
                                      width: "100px",
                                    }}
                                    onClick={() => {
                                      setFormData({
                                        scheduledDate: v?.scheduledDate,
                                        scheduledTime: v?.scheduledTime,
                                      });
                                      setPopUpDetails(v);
                                    }}
                                  >
                                    Edit
                                  </button>
                                </td>
                              </tr>
                              <div className="py-2"></div>
                            </>
                          ))}
                    </tbody>
                  </table>
                  {list?.length == 0 && !showSkelton && <NoRecordFound theme="light" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* sectionLayout ended */}
      {/* sectionLayout ended */}
      {popupDetails?._id && (
        <div
          className="modal fade show d-flex align-items-center appointmentPopup  justify-content-center "
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{ borderRadius: "16px", background: "#f7f7f5", height: "416px", width: "364px" }}
            >
              <div className="d-flex justify-content-between p-4 w-100 ">
                <h5 className="">Update Appointment</h5>
                <i
                  className="fa fa-close text-secondary"
                  onClick={() => {
                    setPopUpDetails(null);
                  }}
                ></i>
              </div>

              <div className="modal-body p-3">
                <div
                  style={{
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  className="d-flex justify-content-center w-100"
                >
                  <div className="w-100">
                    <h3>Name : {popupDetails?.fullName}</h3>
                    <select
                      className="form-control"
                      value={formData?.scheduledDate}
                      onChange={(e) => setFormData({ ...formData, scheduledDate: e.target.value })}
                    >
                      <option value="">Enter Date</option>
                      {popupDetails?.bookingDate?.map((v, i) => {
                        return <option value={v}>{moment(v).format("Do MMM")}</option>;
                      })}
                    </select>
                    <select
                      className="form-control"
                      value={formData?.scheduledTime}
                      onChange={(e) => setFormData({ ...formData, scheduledTime: e.target.value })}
                    >
                      <option value="">Enter Time</option>
                      {timeSlot?.map((v, i) => {
                        return <option>{v}</option>;
                      })}
                    </select>
                    {formData?.scheduledDate && formData?.scheduledTime ? (
                      btnLoader ? <button style={{opacity:"0.5"}}>Updating ...</button>: <button onClick={updateBookingFunc}>Submit</button>
                      
                    ) : (
                      <button style={{ opacity: "0.5" }}>Submit</button>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center"></div>
              </div>
            </div>
          </div>
        </div>
      )}
      {popupDetails?._id && <div className="modal-backdrop fade show"></div>}
    </div>
  );
}

export default AppointmentSchedule;
